import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const Zap = (props: SvgIconProps) => (
  <SvgIcon
    viewBox="0 0 48 49"
    {...props}
    sx={{ fill: 'none', ...(props.sx || {}) }}
  >
    <g clipPath="url(#clip0_614_2767)">
      <path
        d="M35.5078 21.4571H30.5081V8.43722C30.5081 5.677 29.3624 4.81769 28.6853 4.55729C28.0083 4.29689 26.5761 4.1667 24.7533 6.24988L9.96274 23.0716C8.40036 24.8683 8.66075 26.1963 8.94719 26.8473C9.23363 27.4723 10.0669 28.5399 12.4365 28.5399H17.4362V41.5598C17.4362 44.32 18.5819 45.1793 19.2589 45.4397C19.4673 45.5179 19.7277 45.5699 20.0401 45.5699C20.8213 45.5699 21.889 45.2054 23.1909 43.7211L37.9815 26.9255C39.5439 25.1548 39.3096 23.8007 39.0231 23.1757C38.7367 22.5247 37.9034 21.4571 35.5078 21.4571ZM36.4192 25.5714L21.6286 42.367C20.7692 43.3566 20.1443 43.5649 19.9881 43.4868C19.8318 43.4347 19.4933 42.8878 19.4933 41.5598V27.4983C19.4933 26.9255 19.0246 26.4567 18.4517 26.4567H12.4626C11.4991 26.4567 10.9783 26.2224 10.8741 25.962C10.77 25.7276 10.9262 25.1548 11.5512 24.4256L26.3157 7.62999C27.0969 6.74463 27.6698 6.48424 27.8781 6.48424C27.9041 6.48424 27.9302 6.48424 27.9302 6.48424C28.0864 6.53632 28.4249 7.08315 28.4249 8.41118V22.4987C28.4249 23.0716 28.8937 23.5403 29.4665 23.5403H35.5078C36.4712 23.5403 37.0181 23.8007 37.1222 24.035C37.2264 24.2694 37.0701 24.8423 36.4192 25.5714Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_614_2767">
        <rect
          width="30.5186"
          height="41.1428"
          fill="currentColor"
          transform="translate(8.74023 4.427)"
        />
      </clipPath>
    </defs>
  </SvgIcon>
);
